const APP_SETTINGS = {
    PAGE_SIZE: 20,
    TITLE: "Sistema registro SNC",
    CICLE_GRAPH_SIZE: 310
}

export default APP_SETTINGS